export default __webpack_public_path__ + "static/media/add-gray-icon.b6e47366.svg";